import { render } from "./CountryCodePicker.vue?vue&type=template&id=56c1bde2&ts=true"
import script from "./CountryCodePicker.vue?vue&type=script&lang=ts"
export * from "./CountryCodePicker.vue?vue&type=script&lang=ts"

import "./CountryCodePicker.vue?vue&type=style&index=0&id=56c1bde2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__